import { render, staticRenderFns } from "./lookcode.vue?vue&type=template&id=856d96a8&scoped=true"
import script from "./lookcode.vue?vue&type=script&lang=js"
export * from "./lookcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856d96a8",
  null
  
)

export default component.exports